import { ITasOccurrence } from "../models/tasOccurrence";
import ApiService from "../services/api";

const tasStatusMap = {
    "OPEN": "Aberto",
    "IN_ANALYSIS": "Análise VWCO",
    "ANSWERED": "Respondido ao dealer",
    "FINISHED": "Finalizado",
    "CANCELLED": "Cancelado",
}

export const fetchTasOccurrences = async (chassis: string): Promise<ITasOccurrence[]> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');
    try {
        const response = await apiService.get(`/vehicles/${chassis}/tas-occurrences`);

        if (response.status === 200) {
            return (response.data as ITasOccurrence[])
                .filter(tas => tas.tasOccurrenceNumber)
                .map(tas => ({
                    ...tas,
                    status: tasStatusMap[tas.status as keyof typeof tasStatusMap],
                }))
                .sort((a, b) => new Date(b.createdAt ?? "").getTime() - new Date(a.createdAt ?? "").getTime());
        } else {
            throw new Error('Erro ao buscar ocorrências TAS');
        }
    } catch (error) {
        console.error('Error fetching tas occurrences:', error);
        throw error;
    }
}

export const fetchTasOccurrence = async (chassis: string, tasNumber: string): Promise<ITasOccurrence | null> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');
    try {
        const response = await apiService.get(`/vehicles/${chassis}/tas-occurrences/${tasNumber}`);
        if (response.status === 200) {
            const data = response.data as ITasOccurrence;
            return {
                ...data,
                status: tasStatusMap[data.status as keyof typeof tasStatusMap],
            };
        } else {
            throw new Error('Erro ao buscar ocorrência TAS');
        }
    } catch (error) {
        console.error('Error fetching tas occurrence:', error);
        throw error;
    }
}